// extracted by mini-css-extract-plugin
export default {"settingGroup":"Settings_settingGroup__32EwN","settingInfo":"Settings_settingInfo__30Zut"};